import { Box, InputAdornment, TextField } from '@material-ui/core'
import { Button } from 'components/facets'
import { CloseButton } from 'react-bootstrap'

export interface TableSearchNavigatorProps {
  searchText: string
  matchIndices: number[]
  currentMatchIndex: number
  placeholderText: string
  setSearchText: React.Dispatch<React.SetStateAction<string>>
  setCurrentMatchIndex: React.Dispatch<React.SetStateAction<number>>
  maxWidth?: string
}

export const TableSearchNavigator = ({
  searchText,
  matchIndices,
  currentMatchIndex,
  placeholderText,
  setSearchText,
  setCurrentMatchIndex,
  maxWidth,
}: TableSearchNavigatorProps): JSX.Element => {
  return (
    <>
      <div className="d-flex align-items-center gap-2 mb-2">
        <div>
          <TextField
            placeholder={placeholderText}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: maxWidth ? maxWidth : '300px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ width: '38px' }}>
                  <div className={searchText !== '' ? 'd-block' : 'd-none'}>
                    <CloseButton onClick={() => setSearchText('')} />
                  </div>
                </InputAdornment>
              ),
            }}
          />
        </div>
        {matchIndices.length > 0 && (
          <div className="d-flex align-items-center gap-2">
            <Box width={40}>
              <span>
                {currentMatchIndex + 1} / {matchIndices.length}
              </span>
            </Box>
            <Button
              variant="outlined"
              size="small"
              onClick={() =>
                setCurrentMatchIndex((prev) => (prev > 0 ? prev - 1 : matchIndices.length - 1))
              }
            >
              Prev
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() =>
                setCurrentMatchIndex((prev) => (prev < matchIndices.length - 1 ? prev + 1 : 0))
              }
            >
              Next
            </Button>
          </div>
        )}
      </div>
    </>
  )
}
